var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57314 10.493L2.29534 6.21916C1.90155 5.82528 1.90155 5.18777 2.29534 4.79389C2.69015 4.40204 3.32918 4.40204 3.72195 4.79389L7.99975 9.0687L12.2765 4.79389C12.6723 4.40204 13.3104 4.40204 13.7031 4.79389C14.099 5.18675 14.099 5.82427 13.7031 6.21916L9.42534 10.493L8.71305 11.2046C8.31824 11.5985 7.68023 11.5985 7.28644 11.2046L6.57314 10.493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.d97b19367f2afc79898f27d97c55a41a.svg";
export { ForwardRef as ReactComponent };